// src/ScrollRestoration.jsx
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Use location.key if available, otherwise fallback to pathname
    const key = location.key || location.pathname;

    // 🔹 When coming via browser Back/Forward
    if (navigationType === "POP") {
      const saved = sessionStorage.getItem(`scroll-${key}`);
      if (saved !== null) {
        window.scrollTo(0, Number(saved));
      }
    } else {
      // 🔹 For normal navigation (Link, navigate, etc.) → Go to top
      window.scrollTo(0, 0);
    }

    // 🔹 Save scroll on every scroll event
    const handleScroll = () => {
      sessionStorage.setItem(`scroll-${key}`, window.scrollY.toString());
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.key, location.pathname, navigationType]);

  return null;
};

export default ScrollRestoration;
